import React, { ChangeEvent, Component } from "react";

import "./ShippingUpchargeDetails.scss";
import IShipping_Detail from "../../../../models/IShipping_Detail";
import PriceUpchargeTypeEnum from "../../../../models/PriceUpchargeTypeEnum";
import IOnGetShipstationServicesForCarrierDTO from "../../../../models/DTO/IOnGetShipstationServicesForCarrierDTO";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import IGetShipstationServicesForCarrierDTO from "../../../../models/DTO/IGetShipstationServicesForCarrierDTO";
import IShipstationServiceTypeDTO from "../../../../models/Shipstation/IShipstationServiceTypeDTO";
import IShipstationCarrierDTO from "../../../../models/Shipstation/IShipstationCarrierDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import IShipping_DetailUI from "../../../../models/IShipping_DetailUI";
import ISupplierModel from "../../../../models/ISupplierModel";
import INotification from "../../../../models/INotification";
import INewShipping_Detail from "../../../../models/INewShipping_Detail";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import { Socket } from "socket.io-client";

interface IShippingServices {
    [key: string]: {
        services: IShipstationServiceTypeDTO[];
        has_default: boolean;
    };
}

type Props = {
    shipstationCarriers: IShipstationCarrierDTO[];
    shippingDetails: IShipping_Detail[];
    updateShippingDetails: (details: IShipping_DetailUI[] | INewShipping_Detail[]) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

type State = {
    shippingDetails: IShipping_DetailUI[];
    shippingServices: IShippingServices;
};

export default class ShippingUpchargeDetails extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            shippingDetails: this.props.shippingDetails,
            shippingServices: this.setupShippingServices(),
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.ShipstationOnGetServicesForCarriers, this.onGetServicesForCarrier);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetServicesForCarriers, this.onGetServicesForCarrier);
    }

    addRow = () => {
        const shippingDetails = this.state.shippingDetails;

        // @ts-expect-error
        shippingDetails.unshift({ is_shipstation: true, shipstation_carrierCode: "", price_upcharge_type_id: "" });

        this.setState({
            shippingDetails,
        });
    };

    setupShippingServices = (): IShippingServices => {
        // we need to actually get the shipping services for EACH of the different currently selected carriers
        // and create the appropriate object and array
        const shippingServices: IShippingServices = {};

        for (const detail of this.props.shippingDetails) {
            if (detail.shipstation_carrierCode) {
                let has_default = false;

                if (shippingServices[detail.shipstation_carrierCode]) {
                    has_default = shippingServices[detail.shipstation_carrierCode].has_default;
                }

                if (detail.is_default) {
                    has_default = detail.is_default;
                }

                shippingServices[detail.shipstation_carrierCode] = {
                    services: [],
                    has_default,
                };
            }
        }

        const carriers = Object.keys(shippingServices);

        for (const carrier of carriers) {
            this.getServicesForCarrier(carrier);
        }

        return shippingServices;
    };

    getServicesForCarrier = (carrierCode: string) => {
        const payload: IGetShipstationServicesForCarrierDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipstation_carrierCode: carrierCode,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationGetServicesForCarriers, payload);
    };

    onGetServicesForCarrier = (data: IOnGetShipstationServicesForCarrierDTO) => {
        const shippingServices = this.state.shippingServices;

        shippingServices[data.carrierCode] = {
            services: data.serviceTypes,
            has_default: shippingServices[data.carrierCode]?.has_default || false,
        };

        this.setState({
            shippingServices,
        });
    };

    handleChange = (e: ChangeEvent<any>, detail: IShipping_DetailUI, index: number) => {
        const value = e.target.value;
        const name = e.target.name;
        const details = this.state.shippingDetails;

        let i = 0;
        for (const arrDetail of details) {
            if (arrDetail.shipstation_carrierCode === detail.shipstation_carrierCode && i === index) {
                // @ts-expect-error
                arrDetail[name] = value;
            }
            i++;
        }

        const availableServices = this.filterAvailableServices(details);

        this.setState(
            {
                shippingDetails: details,
                // availableServices,
            },
            () => {
                this.props.updateShippingDetails(this.state.shippingDetails);
            }
        );
    };

    filterAvailableServices = (details: IShipping_DetailUI[]): IShippingServices => {
        const availableServices = {};

        return availableServices;
    };

    getFilteredServiceOptions = (carrierCode?: string): IShipstationServiceTypeDTO[] => {
        if (carrierCode) {
            const shippingServices = this.state.shippingServices;

            if (shippingServices) {
                if (shippingServices[carrierCode]) {
                    return shippingServices[carrierCode].services || [];
                } else {
                    this.getServicesForCarrier(carrierCode);
                    return [];
                }
            } else {
                return [];
            }
        } else {
            return [];
        }
    };

    removeDetail = (shippingDetail: IShipping_DetailUI, index: number) => {
        const shippingDetails = this.state.shippingDetails;

        let isSplice = true;

        let i = 0;
        for (const detail of shippingDetails) {
            if (
                detail.shipstation_carrierCode === shippingDetail.shipstation_carrierCode &&
                detail.shipstation_serviceType === shippingDetail.shipstation_serviceType &&
                i === index
            ) {
                isSplice = false;
                detail.deleteFlag = !detail.deleteFlag;
            }

            i++;
        }

        if (isSplice) {
            shippingDetails.splice(index, 1);
        }

        this.setState({
            shippingDetails,
        });
    };

    render() {
        const priceUpchargeOptions = [
            { value: PriceUpchargeTypeEnum.PERCENT, title: "percent" },
            { value: PriceUpchargeTypeEnum.FIXED, title: "fixed" },
        ];

        return (
            <div className={"ShippingUpchargeDetails"}>
                <div className={"title-row"}>
                    <OwTitle title={"shipping_upcharge_details"} tag={"h6"} isUnderline={true} />
                    <div>
                        <OwButton title={"add"} leftIconClass={"fas fa-plus"} fn={this.addRow} />
                    </div>
                </div>

                <div className="details-rows">
                    {this.state.shippingDetails.map((shippingDetail, index) => {
                        return (
                            <div key={shippingDetail.guid}>
                                {shippingDetail.deleteFlag ? (
                                    <div className={"w-100"}>
                                        <OwLabel title={"marked_for_delete"} className={"text-danger"} />
                                    </div>
                                ) : null}
                                <div className={"detail-row"}>
                                    <div className={"w-10 justify-content-center"}>
                                        <i
                                            className={
                                                "fad me-2 pointer " +
                                                (shippingDetail.deleteFlag ? "fa-undo text-primary" : "fa-trash-alt text-danger")
                                            }
                                            onClick={() => {
                                                this.removeDetail(shippingDetail, index);
                                            }}
                                        />
                                    </div>

                                    <div className={"w-90"}>
                                        <div className={""}>
                                            <OwLabel title={"carrier"} />
                                            <OwSelectOption
                                                titleProp={"name"}
                                                valueProp={"code"}
                                                selectedOption={shippingDetail}
                                                selectedOptionProp={"shipstation_carrierCode"}
                                                fn={(e: any) => {
                                                    this.handleChange(e, shippingDetail, index);
                                                }}
                                                options={this.props.shipstationCarriers}
                                                name={"shipstation_carrierCode"}
                                                showBlankFirst={true}
                                            />
                                        </div>

                                        {shippingDetail.shipstation_carrierCode &&
                                        (!this.state.shippingServices[shippingDetail.shipstation_carrierCode]?.has_default ||
                                            shippingDetail.is_default) ? (
                                            <div>
                                                <OwCheckbox
                                                    name={"is_default"}
                                                    fn={(e) => {
                                                        this.handleChange(e, shippingDetail, index);
                                                    }}
                                                    checked={shippingDetail.is_default}
                                                    truthyVal={true}
                                                    falsyVal={false}
                                                    label={"is_default_for_carrier"}
                                                />
                                            </div>
                                        ) : null}

                                        {shippingDetail.is_default ? null : (
                                            <div className={""}>
                                                <OwLabel title={"service"} />
                                                <OwSelectOption
                                                    titleProp={"name"}
                                                    valueProp={"code"}
                                                    selectedOption={shippingDetail}
                                                    selectedOptionProp={"shipstation_serviceType"}
                                                    fn={(e: any) => {
                                                        this.handleChange(e, shippingDetail, index);
                                                    }}
                                                    options={this.getFilteredServiceOptions(shippingDetail.shipstation_carrierCode)}
                                                    name={"shipstation_serviceType"}
                                                    showBlankFirst={true}
                                                />
                                            </div>
                                        )}

                                        <div>
                                            <OwLabel title={"upcharge"} />
                                            <OwInputWrapper
                                                type={"number"}
                                                value={shippingDetail.price_upcharge}
                                                name={"price_upcharge"}
                                                fn={(e: any) => {
                                                    this.handleChange(e, shippingDetail, index);
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <OwLabel title={"upcharge_type"} />
                                            <OwSelectOption
                                                translateTitle={true}
                                                titleProp={"title"}
                                                valueProp={"value"}
                                                selectedOption={shippingDetail}
                                                selectedOptionProp={"price_upcharge_type_id"}
                                                name={"price_upcharge_type_id"}
                                                options={priceUpchargeOptions}
                                                fn={(e: any) => {
                                                    this.handleChange(e, shippingDetail, index);
                                                }}
                                                showBlankFirst={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
